import Model from '../../ModelBinding/Model';
import EquipmentCollection from './EquipmentCollection';
import dayjs from 'dayjs';

export default class Equipment extends Model {
  public type?: string;
  public brand?: string;
  public model?: string;
  public name?: string;
  public production_year?: number;
  public weight?: number;
  public price?: number;
  public dxo_score?: number;
  public resolution?: number;
  public gps?: boolean;
  public sensor_format?: string;
  public color_depth_bits?: number;
  public dynamic_range_evs?: number;
  public iso_to_snr?: number;
  public is4k?: boolean;
  public sharpness?: number;
  public distortion?: number;
  public vignetting?: number;
  public transmission?: number;
  public chromatic_aberration?: number;
  public created_at?: dayjs.Dayjs;
  public updated_at?: dayjs.Dayjs;

  bind() {
    this.type = this.getStringAttribute('type');
    this.brand = this.getStringAttribute('brand');
    this.model = this.getStringAttribute('model');
    this.name = this.getStringAttribute('name');
    this.production_year = this.getIntAttribute('production_year');
    this.weight = this.getIntAttribute('weight');
    this.price = this.getIntAttribute('price');
    this.dxo_score = this.getIntAttribute('dxo_score');
    this.resolution = this.getFloatAttribute('resolution');
    this.gps = this.getBooleanAttribute('gps');
    this.sensor_format = this.getStringAttribute('sensor_format');
    this.color_depth_bits = this.getFloatAttribute('color_depth_bits');
    this.dynamic_range_evs = this.getFloatAttribute('dynamic_range_evs');
    this.iso_to_snr = this.getIntAttribute('iso_to_snr');
    this.is4k = this.getBooleanAttribute('is4k');
    this.sharpness = this.getIntAttribute('sharpness');
    this.distortion = this.getFloatAttribute('distortion');
    this.vignetting = this.getFloatAttribute('vignetting');
    this.transmission = this.getFloatAttribute('transmission');
    this.chromatic_aberration = this.getIntAttribute('chromatic_aberration');
    this.created_at = this.getDateAttribute('created_at');
    this.updated_at = this.getDateAttribute('updated_at');
  }

  static getCollection() {
    return EquipmentCollection;
  }

  toString() {
    if (this.type === 'smartphone') return this.model;
    if (this.name) return this.name;
    return `${this.brand || ''} ${this.model || ''}`.trim();
  }
}
